export const MAX_SIZE_PERIOD_LIST: number = 22;
export const DEFAULT_MIN_PERIOD: number = 90;
export const DEFAULT_MAX_PERIOD: number = 732;
export const DEFAULT_YEAR_PERIOD: number = 366;
export const PERIOD_INCREMENT: number = 30;
